




import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'

@Component
export default class PdTab extends mixins(BaseTab) {
  @Prop(Number) patientId!: number
  @Prop({ default: null, type: Number }) year!: number | null
  @Prop({ default: null, type: Number }) month!: number | null
}
